import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0474e416"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq__item" }
const _hoisted_2 = { class: "faq__question" }
const _hoisted_3 = { class: "faq__answer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpenIcon = _resolveComponent("OpenIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "question", {}, undefined, true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["faq__open-icon", {'open': _ctx.showAnswer}]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAnswerClick && _ctx.showAnswerClick(...args)))
      }, [
        _createVNode(_component_OpenIcon)
      ], 2)
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "answer", {}, undefined, true)
        ], 512), [
          [_vShow, _ctx.showAnswer]
        ])
      ]),
      _: 3
    })
  ]))
}